import { render, staticRenderFns } from "./TratamientosPlan.vue?vue&type=template&id=3a278ae2&scoped=true"
import script from "./TratamientosPlan.vue?vue&type=script&lang=js"
export * from "./TratamientosPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a278ae2",
  null
  
)

export default component.exports